import { Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { authGuard } from './core/auth/auth-guard.guard';
import { BreadcrumbType } from './shared/enums/breadcrumb-type.enum';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/home/home.component').then((m) => m.HomeComponent),
        data: {
          breadcrumbs: [BreadcrumbType.Home],
        },
      },

      {
        path: 'brc',
        loadChildren: () =>
          import('./features/budgetary-responsibility-center/brc.routes').then(
            (m) => m.brcRoutes,
          ),
      },

      {
        path: 'as',
        loadChildren: () =>
          import('./features/analytical-sections/as.routes').then(
            (m) => m.asRoutes,
          ),
      },
      {
        path: 'uo',
        loadChildren: () =>
          import('./features/organizational-units/uo.routes').then(
            (m) => m.uoRoutes,
          ),
      },

      {
        path: 'access-denied/:error',
        loadComponent: () =>
          import('./core/error/error.component').then((c) => c.ErrorComponent),
      },
    ],
  },

  // Redirect to home page if route not exist
  { path: '**', redirectTo: '/', pathMatch: 'full' },
];
